export const WIDGET_NAMES = {
  FAVOURITE_GAMES: 'favouriteGamesWidget',
  GAMES: 'gamesWidget',
  PROVIDERS: 'providersWidget',
  RECENT_GAMES: 'recentGamesWidget',
  SLIDER: 'sliderWidget',
  LOGIN: 'loginWidget',
  THEMES: 'themesWidget',
  JACKPOT_TICKER: 'jackpotTickerWidget',
  CATEGORIES: 'categoriesWidget',
  CATEGORIES_LINE: 'categoriesLineWidget',
  NAVIGATION: 'navigationWidget',
  RECOMMENDED_GAMES: 'recommendedGamesWidget',
  APPLICATION_INSTALL: 'applicationInstallWidget',
  GAME_OF_THE_DAYS: 'gameOfTheDaysWidget',
  CROSS_SALE_WIDGET: 'crossSaleWidget',
  RANDOM_SLOT_WIDGET: 'randomSlotWidget',
  BIG_WINS: 'bigWinsWidget',
  DEPOSIT: 'depositWidget',
  RECENT_THEMES: 'recentThemes',
  RECENT_PROVIDERS: 'recentProviders',
  SLIDER_NAVIGATION: 'sliderNavigationWidget',
  PROMO_WIDGET: 'promoWidget',
};
